import { render, staticRenderFns } from "./CanadaProvincesSelector.vue?vue&type=template&id=594c3343&"
import script from "./CanadaProvincesSelector.vue?vue&type=script&lang=js&"
export * from "./CanadaProvincesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports